// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__UjEjg","modal":"Modal_modal__aWASd","slide-down":"Modal_slide-down__QU5-9"};